import script from "./ProfileBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileBlock.vue?vue&type=style&index=0&id=3ba9e0d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ba9e0d7"]])

export default __exports__